export default __webpack_public_path__ + "static/media/485x250-media.3fae30d6.jpg";